import DateUtils from 'utils/date_utils';
import { formatToNumber, formatCurrency, formatDecimal } from 'utils/formatting_utils';

export const formatFieldValue = value => {
	if (DateUtils.isISO8601DateGlobal(value)) {
		return DateUtils.convertDateStringToMomentGlobal(value);
	}
	return value;
};

export const formatFieldNumericValue = (value, maxLength, digits, type) => {				
	const numericValue = formatToNumber(value);
	let valueFormatted = null;		

	switch (type) {
		case 'CURRENCY':
			valueFormatted = formatCurrency(numericValue, 'number');
			break;
		case 'DECIMAL':			
			valueFormatted = formatDecimal(numericValue, maxLength, digits, 'number');
			break;
		case 'NUMBER':			
			valueFormatted = numericValue;			
			break;
		default:
			break;
	}		

	return valueFormatted;
};

export default {
	formatFieldValue,
	formatFieldNumericValue
};
